import { owcTheme } from 'core/theme/theme.config';
import { PocCard } from 'commons/components/components-wrapper/poc-card.component';
import { Input, SearchableDropdown, WorkflowOverlayComponent } from 'commons/components';
import styled from 'styled-components';

export const PredefinedCommentWorkflowOverlayComponent = styled(WorkflowOverlayComponent)`
    div[slot='content'] {
        display: flex;
        flex-direction: column;
        background-color: ${owcTheme['one-color-gray-50']} !important;
    }
`;

export const PredefinedCommentFormContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    align-items: center;
    padding: 2rem;
    overflow: auto;
`;

export const PredefinedCommentFormCard = styled(PocCard)`
    width: 600px;

    /* OWC-OVERRIDE: stack the form fields with the card's v6 padding. owc-card's content
       wrapper is a plain block with zero padding in v7.6.0 and exposes no layout or padding
       prop. */
    > .owc-card__content-wrapper {
        display: flex;
        flex-direction: column;
        padding: 1rem 1.5rem;
    }
`;

export const PredefinedCommentFormCardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    owc-input,
    owc-select-dropdown {
        width: 100%;
    }
`;

export const PredefinedCommentFormCardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const PredefinedCommentFormFieldRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.5rem;
`;

export const PredefinedCommentFormFieldRowLabel = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

/* OWC-OVERRIDE: fill the form row. owc-input has a ~250px default width on its host and no
   width prop in v7.6.0; matching its own class raises specificity enough to win. */
export const PredefinedCommentOwcInput = styled(Input)`
    &.owc-input {
        width: 100%;
    }
`;

export const PredefinedCommentPriorityInputWrapper = styled.div`
    flex-shrink: 0;
    width: 7.5rem;

    /* OWC-OVERRIDE: fill the fixed-width priority column. owc-input has a ~250px default width
       on its host and no width prop in v7.6.0; the doubled class beats owc's own :host rule. */
    owc-input.owc-input {
        width: 100%;
    }
`;

export const LocationsSearchableDropdown = styled(SearchableDropdown)`
    /**
     * Since this dropdown is filled by default with all locations, the tooltip interferes with the user experience
     * Hence, we hide the tooltip for this specific dropdown, while keeping it for the rest of the form.
     */
    owc-tooltip {
        display: none;
    }
`;
